import React from 'react';
import HeaderSidebar from '../../components/LayoutTele/HeaderSidebar';
import LayoutTele from '../../components/LayoutTele/LayoutTele';

/* eslint-disable */
const PatientDashboard = () => {
  return (
    <LayoutTele>
      <HeaderSidebar />
      <p>This is layout tele children</p>
    </LayoutTele>
  );
};

export default PatientDashboard;
